import { ITimeRangeResponse } from '@kcftech/prometheustypescriptapiclient';
import { sdClient } from 'contexts/SDKClientContext';
import {
    BaseDataSourceOptions,
    DataSourceQuery,
} from 'custom_hooks/data_hooks/data_source/data_source';
import {
    InfiniteDataSource,
    useInfiniteDataSource,
} from 'custom_hooks/data_hooks/data_source/useInfiniteDataSource';
import {
    PagedDataSource,
    usePagedDataSource,
} from 'custom_hooks/data_hooks/data_source/usePagedDataSource';
import { buildOrderBy, toDataSourceResult } from 'utils/query_v3';

export type TimeRangeFilter = Readonly<{
    nameSearch: string | undefined;
}>;

export type UseTimeRangeDataSourceOptions = BaseDataSourceOptions<
    ITimeRangeResponse,
    TimeRangeFilter
>;

export type TimeRangePagedDataSource = PagedDataSource<
    ITimeRangeResponse,
    TimeRangeFilter
>;

const queryFn: DataSourceQuery<ITimeRangeResponse, TimeRangeFilter> = ({
    filter: { nameSearch },
    sort,
    page,
    pageLimit,
}) => {
    const orderBy = buildOrderBy(sort);
    return toDataSourceResult(
        sdClient.getRanges({ page, pageLimit, orderBy, nameSearch })
    );
};

export function usePagedTimeRangeDataSource(
    options: UseTimeRangeDataSourceOptions
): TimeRangePagedDataSource {
    return usePagedDataSource({ ...options, query: queryFn });
}

export type TimeRangeInfiniteDataSource = InfiniteDataSource<
    ITimeRangeResponse,
    TimeRangeFilter
>;

export function useInfiniteTimeRangeDataSource(
    options: UseTimeRangeDataSourceOptions
): TimeRangeInfiniteDataSource {
    return useInfiniteDataSource({ ...options, query: queryFn });
}
